// Stream addons do not provide a standard audio-language field. Only label
// languages explicitly identified as audio or as a stream-language tag.
const LANGUAGE = '(?:pt[-_ ]?br|pt[-_ ]?pt|portugu[eê]s(?:e)?|english|ingl[eê]s|en(?:[-_ ]?us)?|es(?:[-_ ]?es)?|espa[nñ]ol|espanhol|spanish|fran[cç]ais|franc[eê]s|french|deutsch|alem[aã]o|german|italiano|italian|japanese|japon[eê]s)';
const EXPLICIT_AUDIO = new RegExp(`(?:^|[\\s|([{])(?:audio|áudio|idioma|language|lang|dubbed|dublado)\\s*[:= -]\\s*(${LANGUAGE})(?=$|[\\s|)\\]},;/])`, 'i');
const TAGGED_LANGUAGE = new RegExp(`(?:\\[|\\()(${LANGUAGE})(?:\\]|\\))`, 'i');

const LABELS = {
    'pt-br': 'Português (Brasil)',
    'pt-pt': 'Português (Portugal)',
    pt: 'Português',
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    it: 'Italiano',
    ja: '日本語'
};

const streamLanguage = (stream) => {
    const name = typeof stream?.name === 'string' ? stream.name : '';
    const description = typeof stream?.description === 'string' ? stream.description : '';
    if (/legendas\s*:\s*portugu[eê]s/i.test(`${name}\n${description}`)) return 'Legendas em Português';
    const match = EXPLICIT_AUDIO.exec(name) || EXPLICIT_AUDIO.exec(description) || TAGGED_LANGUAGE.exec(name);
    if (!match) return null;

    const value = match[1].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[_ ]/g, '-');
    if (value === 'pt-br' || value === 'pt-pt') return LABELS[value];
    if (value.startsWith('portug')) return LABELS.pt;
    if (['english', 'ingles', 'en', 'en-us'].includes(value)) return LABELS.en;
    if (['espanol', 'spanish', 'es', 'es-es'].includes(value)) return LABELS.es;
    if (['francais', 'frances', 'french'].includes(value)) return LABELS.fr;
    if (['deutsch', 'alemao', 'german'].includes(value)) return LABELS.de;
    if (['italiano', 'italian'].includes(value)) return LABELS.it;
    if (['japanese', 'japones'].includes(value)) return LABELS.ja;
    return null;
};

module.exports = streamLanguage;
